import React from 'react';
import $ from "jquery";
import Server from '../../functions/server';
import Loading from '../loading';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

class Mrphistory extends React.Component {

  state = {
    open: false,
    fullWidth: true,
    maxWidth: 'sm',
    data: []
  }

  getHistory() {
    let context = this;
    let partno = this.props.partno;
    $.ajax({
      type: 'POST',
      data: { 'partno': partno, 'brand': context.props.brand_id },
      url: Server() + 'spares/gethistory.php',
      success: function(data)
      {
        console.log(data);
        try {
          data = JSON.parse(data);
          context.setState({ data: data, open: true })
        } catch (e) {

        }
      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  render() {
    let  i = 0;
    return (
      <div>
        <u style={{cursor: 'pointer', color: 'blue'}} onClick={this.getHistory.bind(this)}>{Number(this.props.mrp).toFixed(2)}</u>
        <Dialog fullWidth={this.state.fullWidth} maxWidth={this.state.maxWidth}
          open={this.state.open} onClose={ () => { this.setState({ open: false }) }} aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">MRP HISTORY</DialogTitle>
          <DialogContent>
            <b style={{color: '#3F6C8D'}}>Spare Name: {this.props.spareName+"("+this.props.partno+")"}</b>
            <table id='table' width='100%'>
              <tr>
                <th id='tableheader'><center>Sino</center></th>
                <th id='tableheader'><center>Partcode</center></th>
                <th id='tableheader'><center>Mrp</center></th>
                <th id='tableheader'><center>Timestamp</center></th>
              </tr>
              { this.state.data.map((x) => {
                  i++;
                  return (
                    <tr>
                      <td><center>{i}</center></td>
                      <td><center>{x.part_alias}</center></td>
                      <td><div align="right">Rs.{Number(x.mrp).toFixed(2)}</div></td>
                      <td><center>{x.timestamp}</center></td>
                    </tr>
                  )
                })
              }
            </table>
          </DialogContent>
          <DialogActions>
            <Button onClick={ () => { this.setState({ open: false }) }} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default Mrphistory;
